import React from 'react';
import classNames from 'classnames';
import styles from '../assets/grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from 'src/components/react-table/Grid';
import { QueryParams } from 'src/types/grid';
import { CellProps } from 'react-table';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import { IWorkedHoursReport } from 'src/store/reducers/workedHoursReport-reducer';
import user from '../../../../../../services/user-auth';
import UserRole from '../../../../../../enumerables/user-role';
import { changeToZeroMoment } from '../../../../../../helpers/timeHelpers';

interface Props {
    data: Paginated<IWorkedHoursReport>;
    getData: (params: QueryParams) => void;
}

const columns: Column<IWorkedHoursReport>[] = [
    {
        Header: 'Month',
        accessor: 'month_start',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IWorkedHoursReport>) =>
            original.month_start ? changeToZeroMoment(original.month_start, 'MMM YYYY') : '',
    },
    {
        Header: 'Provider',
        accessor: 'full_name',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IWorkedHoursReport>) => {
            if (user.getRoles().includes(UserRole.ROLE_ADMIN)) {
                return (
                    <Link
                        to={Router.generate(routes.PROVIDER_DETAIL, {
                            id: original.provider_id,
                            tab: 'main-info',
                            subId: '',
                        })}
                    >
                        {original.full_name}
                    </Link>
                );
            }
            return original.full_name ?? '';
        },
    },
    {
        Header: 'Avg Hours',
        accessor: 'avg_hours',
        disableSortBy: true,
        disableFilters: true,
        Cell: ({
            cell: {
                row: { original },
            },
        }: CellProps<IWorkedHoursReport>) => (original.avg_hours ? Number(original.avg_hours).toFixed(2) : ''),
    },
];

const WorkedHoursReportGrid: React.FunctionComponent<Props> = ({ data, getData }: Props) => {
    return (
        <div className={classNames(styles.grid)}>
            <Grid<IWorkedHoursReport> columns={columns} data={data} getData={getData} noPagination={true} />
        </div>
    );
};

export default WorkedHoursReportGrid;
